const ARGENTINA_TIME_ZONE = 'America/Argentina/Buenos_Aires';
const timeOptions = { timeZone: ARGENTINA_TIME_ZONE, hour: '2-digit', minute: '2-digit', second: '2-digit', hourCycle: 'h23' };

// Sólo timestamps de origen del chat: Mongo/API puede devolver UTC sin sufijo.
// No usar este parser para fechas bancarias ni horas editadas por el operador.
export const parseChatTimestamp = value => {
  if (value instanceof Date) return Number.isFinite(value.getTime()) ? value : null;
  if (typeof value !== 'string') return null;
  let normalized = value.trim().replace(' ', 'T');
  if (!/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}(?::\d{2}(?:\.\d+)?)?(?:Z|[+-]\d{2}:?\d{2})?$/i.test(normalized)) return null;
  normalized = normalized.replace(/(\.\d{3})\d+/, '$1');
  if (!/(?:Z|[+-]\d{2}:?\d{2})$/i.test(normalized)) normalized += 'Z';
  const date = new Date(normalized);
  return Number.isFinite(date.getTime()) ? date : null;
};

export const formatChatTime = value => {
  const date = parseChatTimestamp(value);
  return date ? date.toLocaleTimeString('es-AR', timeOptions) : 'Hora no disponible';
};

export const formatChatDateTime = value => {
  const date = parseChatTimestamp(value);
  return date ? date.toLocaleString('es-AR', {
    ...timeOptions, year: 'numeric', month: 'numeric', day: 'numeric',
  }) : 'Hora no disponible';
};